import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageResolver implements Resolve<boolean> {
  private readonly response: Response;

  constructor(@Optional() @Inject(RESPONSE) response: Response, private translocoService: TranslocoService, private router: Router) {
    this.response = response;
  }

  public async resolve(route: ActivatedRouteSnapshot): Promise<boolean> {
    const lang: string = route.params?.['lang'] ?? this.translocoService.getDefaultLang();
    if (!(this.translocoService.getAvailableLangs() as string[]).includes(lang)) {
      await this.languageNotFound();
      return false;
    }

    this.translocoService.setActiveLang(lang);
    // QuantityUnitNamePipe / ArticleUnitNamePipe are pure and translate synchronously from the `shared` scope.
    // Nothing preloads that scope during SSR (the browser-only cookie consent does it on the client), so the
    // pipes would cache the raw unit code. Loading it here makes every route render with the scope available.
    await firstValueFrom(this.translocoService.load(`shared/${lang}`));
    return true;
  }

  private async languageNotFound(): Promise<void> {
    // this will only be sent in SSR environment
    if (this.response) {
      return this.response.redirect(302, '/');
    }

    await this.router.navigate(['/']);
  }
}
